import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'

const LeadCreateModal = ({ modal, toggle, isEdit, LeadListApi, editData, leadId }) => {

    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [leadTypeValue, setLeadTypeValue] = useState(editData?.LeadTypeId || 0)
    const [leadType, setLeadType] = useState([])
    const [handleByValue, setHandleByValue] = useState(editData?.HandleBy || 0)
    const [userData, setUserData] = useState([])
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [leaderror, setLeadError] = useState(false)

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUserData(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

        getApi('Lead/type/lookup').then(({ data, status }) => {
            if (status === 200) {
                setLeadType(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])


    useEffect(() => {
        if (!isEdit) {
            validation.setFieldValue("Name", '')
            validation.setFieldValue("ContactNo", '')
            validation.setFieldValue("Address", '')
            validation.setFieldValue("Remark", '')
            setLeadTypeValue(0)
            setHandleByValue(0)
        } else {
            setLeadTypeValue(editData?.LeadTypeId)
            setHandleByValue(editData?.HandleBy)
        }
    }, [isEdit, editData])



    // Lead Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Name: editData ? editData?.Name : '',
            ContactNo: editData ? editData?.ContactNo : '',
            LeadType: 0,
            HandleBy: 0,
            Address: editData ? editData?.Address : '',
            Remark: editData ? editData?.Remark : "",
        },
        validationSchema: Yup.object({
            Name: Yup.string().required("The name is required"),
            ContactNo: Yup.string().required("The contact no. is required"),
            Address: Yup.string().required("The address is required"),
            Remark: Yup.string().required("The remark is required"),
        }),
        onSubmit: values => {

            if (leadTypeValue == 0 && !isEdit) {
                setLeadError(true)
                return true
            }

            setformSumitLoading(true)
            if (values) {
                setLeadError(false)
                isEdit ?
                    putApi("Lead/update", {
                        Id: editData.Id,
                        name: values.Name,
                        contactNo: values.ContactNo,
                        LeadTypeId: parseInt(leadTypeValue),
                        handleBy: parseInt(handleByValue),
                        address: values.Address,
                        remark: values.Remark,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            if (LeadListApi) {
                                LeadListApi()
                            }
                            toggle()
                            validation.handleReset()
                        }
                    })
                    :
                    postApi("Lead/create", {
                        name: values.Name,
                        contactNo: values.ContactNo,
                        LeadTypeId: parseInt(leadTypeValue),
                        handleBy: parseInt(handleByValue),
                        address: values.Address,
                        remark: values.Remark,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (LeadListApi) {
                                LeadListApi()
                            }
                            validation.handleReset()
                        }
                    })
            }
        },
    })

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)

    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: !isMobile ? "400px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Lead" : "Create Lead"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={8}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Name
                                    </Label>
                                    <Input
                                        name="Name"
                                        placeholder="Name"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Name}
                                        invalid={
                                            validation.touched.Name && validation.errors.Name
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Name && validation.errors.Name ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Name}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Contact No.
                                    </Label>
                                    <Input
                                        name="ContactNo"
                                        placeholder="contact no."
                                        type="text"
                                        maxLength={10}
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        onKeyPress={handleKeyPress}
                                        value={validation.values.ContactNo}
                                        invalid={
                                            validation.touched.ContactNo && validation.errors.ContactNo
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.ContactNo && validation.errors.ContactNo ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.ContactNo}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Lead Type
                                    </Label>
                                    <Input
                                        // disabled={handleByValue == 0}
                                        type="select"
                                        bsSize="sm"
                                        id="validationCustom01"
                                        className="form-control-sm"
                                        name="leadType"
                                        // onChange={validation.handleChange}
                                        onChange={e => {
                                            setLeadTypeValue(e.target.value)
                                            setLeadError(false)
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={leadTypeValue}
                                    >
                                        <option>Select lead type</option>
                                        {leadType.map((item, index) => {
                                            return (
                                                <option key={index} value={item.Key}>
                                                    {item.Value}
                                                </option>
                                            )
                                        })}
                                    </Input>
                                    {leaderror ? (
                                        <div className="name-required">
                                            {" Lead Type is Required"}
                                        </div>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className=""
                                    >
                                        Handle By
                                    </Label>
                                    <Input
                                        type="select"
                                        bsSize="sm"
                                        id="validationCustom01"
                                        className="form-control-sm"
                                        name="Handleby"
                                        // onChange={validation.handleChange}
                                        onChange={e => {
                                            setHandleByValue(e.target.value)
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={handleByValue}
                                    >
                                        <option value={0}>handle by</option>
                                        {userData.map((item, index) => {
                                            return (
                                                <option key={index} value={item.Key}>
                                                    {item.Value}
                                                </option>
                                            )
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <FormGroup className="mb-2">
                                <Label htmlFor="validationCustom03" className="required">
                                    Address
                                </Label>
                                <Input
                                    name="Address"
                                    placeholder="Enter address here"
                                    type="textarea"
                                    className="form-control-sm"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.Address}
                                    invalid={
                                        validation.touched.Address && validation.errors.Address
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.Address && validation.errors.Address ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.Address}
                                    </FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup className="mb-2">
                                <Label htmlFor="validationCustom03" className="required">
                                    Remark
                                </Label>
                                <Input
                                    name="Remark"
                                    placeholder="Enter remark here"
                                    type="textarea"
                                    className="form-control-sm"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.Remark}
                                    invalid={
                                        validation.touched.Remark && validation.errors.Remark
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.Remark && validation.errors.Remark ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.Remark}
                                    </FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Row>

                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                type="reset"
                                color="secondary"
                            >
                                Reset
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default LeadCreateModal